import React from 'react'

import Box from 'components_new/atoms/Box'
import TextField from 'components_new/atoms/TextField'

import SelectSearch from 'components_new/molecules/SelectSearch'

import { AUTH_OPTIONS } from 'utils/sources'

export type TCustomAuth = {
  field: string
  location: string
  value: string
}

interface CustomAuthStepProps {
  onChange: (values: TCustomAuth) => void
  values: TCustomAuth
}

/**
 * Custom API sources describe their own authentication instead of declaring
 * auth params up front, so there is nothing to validate against.
 */
const CustomAuthStep = (props: CustomAuthStepProps) => {
  const { onChange, values } = props

  const selected =
    AUTH_OPTIONS.find((item) => item.id === values.location) ?? null

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <SelectSearch
        closeOnSelect={true}
        disableClearable={true}
        multiple={false}
        onChange={(location) => onChange({ ...values, location: location.id })}
        options={AUTH_OPTIONS}
        placeholder="Välj typ..."
        selected={selected}
        size="medium"
      />
      <TextField
        label="Fält"
        onChange={(event) => onChange({ ...values, field: event.target.value })}
        value={values.field}
      />
      <TextField
        label="Värde"
        onChange={(event) => onChange({ ...values, value: event.target.value })}
        value={values.value}
      />
    </Box>
  )
}

export default CustomAuthStep
